import { TeamResponse } from '@dto/api';

export enum ImageCategory {
  LOGO = 100,
}

export interface ImageUploadResponse {
  id: string;
  category: number;
  filenameOrig?: string;
  refOrig?: string;
  urlOrig?: string;
  urlT150?: string;
}

export interface UseFileUploadResult {
  uploading: boolean;
  error: string | null;
  uploadFile: (
    file: File,
    category: ImageCategory
  ) => Promise<ImageUploadResponse | null>;
}

export interface TeamInfoPayload {
  nameLong: string;
  sport: string;
  attrib_ageLevel: string;
  isAge13Plus: boolean;
  localTzString: string;
  imageId?: string;
  nameHandle?: string;
}
export interface UseSaveTeamInfoResult {
  saving: boolean;
  error: string | null;
  saveTeamInfo: (payload: TeamInfoPayload) => Promise<TeamResponse>;
}

export interface TeamTrackInfo {
  gameCount: number;
  playerCount: number;
}
